var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('app-info',{attrs:{"appInfo":_vm.appInfo,"no-refresh":true},on:{"refreshData":_vm.refreshAppData}})],1),_c('div',{staticClass:"col-3"},[_c('db-info',{attrs:{"dbInfo":_vm.dbInfo,"no-refresh":true},on:{"refreshData":_vm.refreshDbData}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }